import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $accountByIdStore } from '@lib/store';
import { AccountType } from '@shared/api';
import { AccountSidebar } from './card';
import { AccountDetails, Documents } from './payment';
import { SidebarSection } from './sidebarSection';

export const Sidebar = () => {
  const accountDetailsStore = useUnit($accountByIdStore.store);

  const { t } = useTranslation('account');

  if (!accountDetailsStore.data) return null;
  return (
    <aside className='flex h-fit min-w-72 flex-col gap-6'>
      {accountDetailsStore.data.type === AccountType.Card && <AccountSidebar />}
      {accountDetailsStore.data.type === AccountType.Payment && (
        <>
          <SidebarSection caption={t('sidebar.accountDetails.title')}>
            <AccountDetails />
          </SidebarSection>
          <SidebarSection caption='Documents'>
            <Documents />
          </SidebarSection>
        </>
      )}
    </aside>
  );
};
